import { scriptTypes } from 'constants/scripts';
import { START_PLANTING_DATE } from 'constants/dates';
import { get } from 'lodash';

export const getActivityCategories = (state) => {
  return get(state, 'activities.categories', {});
};

export const getActivityDefaultDates = (state) => {
  return get(state, 'activities.defaultDates');
};

export const getActivityCategoriesByUuid = (state) => {
  return get(getActivityCategories(state), 'byUuid');
};

export const getActivityCategoriesByActivityType = (state) => {
  return get(getActivityCategories(state), 'byActivityType');
};

export const getActivityTypeByActivityCategoryUuid = (state, activityCategoryUuid) => {
  return get(getActivityCategoriesByUuid(state), `${activityCategoryUuid}.activityType`);
};

export const getFertilityActivityCategoriesOrdered = (state) => {
  return get(getActivityCategories(state), `ordered.fertility`, []);
};

export const getApplicationActivityCategoriesOrdered = (state) => {
  return get(getActivityCategories(state), `ordered.application`, []);
};

export const getAllActivities = (state) => {
  return get(state, 'activities.allActivities');
};

export const getAllActivitiesByActivityType = (state) => {
  return get(getAllActivities(state), 'byActivityType');
};

export const getAllActivitiesByUuid = (state) => {
  return get(getAllActivities(state), 'byUuid');
};

export const getActivityByActivityType = (state, activityType ) => {
  return get(getAllActivitiesByActivityType(state), activityType);
};

export const getActivityByActivityCategoryUuid = (state, activityCategoryUuid ) => {
  const activityType = getActivityTypeByActivityCategoryUuid(state, activityCategoryUuid);
  return getActivityByActivityType(state, activityType);
};

export const getActivityByUuid = (state, uuid) => {
  return get(getAllActivitiesByUuid(state), uuid);
};

export const getActivitiesByTypeAndDate = (state, activityCategoryUuid, date) => {
  const activityType = getActivityTypeByActivityCategoryUuid(state, activityCategoryUuid);
  const byUuid = getAllActivitiesByUuid(state);
  return Object.values(byUuid || {})
  .find(activity => activity.date.slice(0, 10) === date.slice(0, 10) && activity.type === activityType);
};

export const getActivitiesOfActivityType = (state, activityCategoryUuid) => {
  const activityType = getActivityTypeByActivityCategoryUuid(state, activityCategoryUuid);
  const byUuid = getAllActivitiesByUuid(state);
  return Object.values(byUuid).filter(activity => activity.type === activityType);
};

export const getDefaultDateForActivityType = (state, activityType) => {
  const category = get(getActivityCategoriesByActivityType(state), activityType);
  return category?.date || START_PLANTING_DATE;
};

export const getDefaultDateForActivityCategoryUuid = (state, activityCategoryUuid) => {
  const category = get(getActivityCategoriesByUuid(state), activityCategoryUuid);
  return category?.date || START_PLANTING_DATE;
};

export const getRecentPlantingActivityUuid = (state) => {
  return get(getAllActivitiesByActivityType(state), `${scriptTypes.PLANTING}.uuid`);
};

export const isActivityPrimaryScript = (state, scriptUuid) => {
  if (!scriptUuid) { throw new Error('Invalid script UUID'); } // Avoid misleading "true" return below.
  const activitiesArray = Object.values(getAllActivitiesByUuid(state));
  return activitiesArray.some(activity => activity.primary === scriptUuid);
};
